import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { z } from "zod";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { FlaskConical } from "lucide-react";

export const Route = createFileRoute("/lab-results/")({
  component: LabResults,
});

function LabResults() {
  const { data, isLoading } = useQuery({
    queryKey: ["lab-tests"],
    queryFn: () => apiFetch("/api/lab/tests", { schema: z.object({ items: z.array(z.any()) }) }).catch(() => ({ items: [] })),
  });

  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <FlaskConical className="h-5 w-5" /> Laboratoire
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Catalogue LOINC + résultats patient</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Tests disponibles</CardTitle>
          <CardDescription>Tests LOINC alignés sur les standards Maroc</CardDescription>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <Skeleton className="h-32 w-full" />
          ) : (
            <ul className="space-y-2">
              {data?.items.map((t: any) => (
                <li key={t.id} className="flex items-center justify-between rounded-md border border-white/5 bg-white/[0.02] p-3">
                  <div>
                    <div className="font-medium">{t.name}</div>
                    <div className="text-xs text-muted-foreground">LOINC: {t.loinc ?? "—"}</div>
                  </div>
                  <Badge variant="outline">{(t.priceCents / 100).toFixed(2)} MAD</Badge>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
